var _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20703 1.80364C2.20703 1.41704 2.52043 1.10364 2.90703 1.10364H13.698C14.2556 1.10364 14.5893 1.72383 14.2822 2.18923L12.439 4.98193C12.2846 5.21581 12.2846 5.51922 12.439 5.75311L14.2822 8.54581C14.5893 9.0112 14.2556 9.6314 13.698 9.6314H2.90703C2.52043 9.6314 2.20703 9.318 2.20703 8.9314V1.80364Z",
    fill: "#FF8934"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.20703,
    width: 2.20718,
    height: 15.4503,
    rx: 1.10359,
    fill: "#4E4E4E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 14.3467,
    width: 6.62155,
    height: 2.20718,
    rx: 1.10359,
    fill: "#4E4E4E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.b514f80704cc7f5178044647700b867f.svg";
export { ForwardRef as ReactComponent };